import React, { useState, useEffect, useMemo } from 'react';
import '../styles/DatePicker.css';

interface DatePickerProps {
  initialDate?: string; // Fecha en formato AAAA-MM-DD
  onDateChange?: (date: string) => void;
  onDateValid?: (isValid: boolean) => void;
  etiqueta: string; // Nueva prop para la etiqueta
  ContainerSX?: React.CSSProperties; // Nueva prop para estilos personalizados
  LabelSX?: React.CSSProperties; // Nueva prop para estilos personalizados
}

const DatePicker: React.FC<DatePickerProps> = ({ initialDate, onDateChange, onDateValid, etiqueta, ContainerSX, LabelSX }) => {

  const parseDate = (date: string) => {
    const [year, month, day] = date.split('-');
    return { day, month, year };
  };
  
  const initialParsedDate = initialDate && initialDate.trim().length > 0 ? parseDate(initialDate) : { day: '', month: '', year: '' };

  const [day, setDay] = useState<string>(initialParsedDate.day);
  const [month, setMonth] = useState<string>(initialParsedDate.month);
  const [year, setYear] = useState<string>(initialParsedDate.year);

  const days = Array.from({ length: 31 }, (_, i) => String(i + 1).padStart(2, '0'));

  const months = [
    'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
  ];

  const monthsInternal = [
    '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'
  ];

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 120 }, (_, i) => String(currentYear - i));

const isValidDate = (): string => {
    if (!day || !month || !year) return '';
    
    const monthIndex = monthsInternal.indexOf(month.toString().padStart(2, '0'));

    if (monthIndex === -1) return '';
    
    const yearNum = parseInt(year);
    const dayNum = parseInt(day);
    
    if (isNaN(yearNum) || isNaN(dayNum)) return '';
    if (yearNum < 1 || yearNum > 9999) return '';
    if (dayNum < 1 || dayNum > 31) return '';
  
    // Crear la fecha
    const date = new Date(yearNum, monthIndex, dayNum);

    // Verificar si la fecha resultante coincide con la entrada
    if (date.getFullYear() === yearNum && 
        date.getMonth() === monthIndex && 
        date.getDate() === dayNum) {
      
      // Formatear la fecha como AAAA-MM-DD
      const formattedMonth = (monthIndex + 1).toString().padStart(2, '0');
      const formattedDay = dayNum.toString().padStart(2, '0');
      return `${yearNum}-${formattedMonth}-${formattedDay}`;
    }
  
    return '';
  };

  const handleDayChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setDay(e.target.value);
  };
  const handleMonthChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setMonth(e.target.value.padStart(2, '0'));
  };
  const handleYearChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setYear(e.target.value);
  };

  const formattedDate = useMemo(() => isValidDate(), [day, month, year]);

  /*useEffect(() => {
    if (formattedDate !== '' && onDateChange) {
      onDateChange(formattedDate);
    }
  
    if (onDateValid) {
      onDateValid(formattedDate !== '');
    }
  }, [formattedDate, onDateChange, onDateValid]);*/

useEffect(() => {
  if (initialDate && initialDate.trim().length > 0) {
    const parsed = parseDate(initialDate);
    setDay(parsed.day);
    setMonth(parsed.month);
    setYear(parsed.year);
    const isValid = isValidDate();
    if (isValid.trim().length === 10) {
      if (onDateChange) onDateChange(isValid);
      if (onDateValid) onDateValid(true);
    } else {
      if (onDateValid) onDateValid(false);
    }
  } else {
    setDay('');
    setMonth('');
    setYear('');
  }
}, [initialDate]);


  useEffect(() => {
    const isValid = isValidDate();
    if (onDateChange && !(isValid === '')) {
      onDateChange(isValid);
    }
    if (onDateValid) {
      if (isValid === '') {
        onDateValid(false);
      } else {
        onDateValid(true);
      }
    }
  }, [day, month, year]);


  return (
    <div className="date-picker-container" style={ContainerSX}>
      <label className="date-picker-label" style={LabelSX}>{etiqueta}</label>
      <div className="date-picker-selects">
        <select className="date-picker-select" value={day} onChange={handleDayChange}>
          <option value="" disabled>Día</option>
          {days.map(d => (
            <option key={d} value={d}>{d}</option>
          ))}
        </select>
        <select className="date-picker-select" value={month} onChange={handleMonthChange}>
          <option value="" disabled>Mes</option>
          {months.map((m, idx) => (
            <option key={idx} value={monthsInternal[idx]}>{m}</option>
          ))}
        </select>
        <select className="date-picker-select" value={year} onChange={handleYearChange}>
          <option value="" disabled>Año</option>
          {years.map(y => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default DatePicker;
